export default "__VITE_ASSET__842813cc__"